export const SET_VIEW = "SET_VIEW";
export const SHOW_CUSTOMER_DETAILS = "SHOW_CUSTOMER_DETAILS";
